/** @format */

import React from "react";
import "./style.scss";
import { Link } from "react-router-dom";
import TransParentui from "../SvgIcons/TransParentui";

export default function Hero() {
  return (
    <section className='herosection'>
      <div className='heroleftside'>
        <h1>
          Never miss a <span>memory,</span> Never struggle to find it.
        </h1>
        {/* <p>We’re coming soon.</p> */}
        <div className='playstore'>
          <Link
            to='https://apps.apple.com/us/app/paths-friends-memories-life/id1480890359'
            target='_blank'
          >
            <img
              src='../images/android.png'
              alt='android'
              className='img-fluid'
            />
          </Link>
          <Link
            to='https://play.google.com/store/apps/details?id=com.getpaths.paths'
            target='_blank'
          >
            <img
              src='../images/googlepaly.png'
              alt='googlepaly'
              className='img-fluid'
            />
          </Link>
        </div>
      </div>

      <div className='herolerightside'>
        <div className='tranparent'>
          <TransParentui />
        </div>
        <div className='frontpic'>
          <div className='memories'>
            Find
            <br /> <span>Memories</span> Fast
          </div>
          <div className='collaborate'>
            <span>COLLABTAB™</span>
            <br /> So They Last
          </div>
          <div className='tandem'>
            <span>TANDEM TIMELINE™</span>
          </div>
          <div className='shareiPhone'>
            <img
              src='../images/iPhone-13-Pro-Front.png'
              alt='hero'
              className='img-fluid'
            />
            <img
              src='../images/Tandom-Timeline.png'
              alt='hero'
              className='img-fluid timelinepic'
            />
          </div>
        </div>
      </div>
    </section>
  );
}
